import styled from 'styled-components';

export const RequirementsWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(25,51,77,0.06);
`;

export const RequirementsTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: #223046;
  margin: 4px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Checklist = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const GroupCard = styled.li`
  background: #ffffff;
  border: 1.5px solid #E7EAEE;
  border-radius: 10px;
  padding: 12px;
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const GroupTitle = styled.div`
  color: #223046;
  font-weight: 700;
`;

export const GroupMeta = styled.div`
  color: #6B7280;
  font-size: 0.9rem;
`;

export const GroupProgressBar = styled.div`
  height: 6px;
  background: #E7EAEE;
  border-radius: 6px;
  overflow: hidden;
  margin: 8px 0 10px 0;
  > div {
    height: 100%;
    background: linear-gradient(90deg, #223046 60%, #7B2639 100%);
  }
`;

export const CourseChips = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 8px;
`;

export const Chip = styled.div<{ $muted?: boolean }>`
  background: ${({ $muted }) => ($muted ? '#FFF7E8' : '#E7F2EC')};
  color: #223046;
  border: 1.5px solid ${({ $muted }) => ($muted ? '#F7E6C3' : '#D5F0DC')};
  border-radius: 8px;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.9rem;
`;

export const Grade = styled.span`
  color: #223046;
  font-weight: 700;
`;

export const ProgressNote = styled.div`
  margin-top: 10px;
  font-size: 0.95rem;
  color: #6B7280;
`;


